module.exports = __webpack_public_path__ + "images/floorplan-example-c5c3542f41c27108ff859375e9f18ad9.png";